import { FunctionComponent } from 'react'
import { Grid } from '@material-ui/core'

import { Subtitle, Text, Title } from './styles'
import { colors } from 'shared/styles/colors'
import { MdOutlinePeopleAlt } from 'react-icons/md'
import Modal from 'shared/components/Modal'
import { BsBriefcase, BsPersonCircle } from 'react-icons/bs'
import { AiOutlineFileText } from 'react-icons/ai'
import Button from 'shared/components/Button'
import { useHistory } from 'react-router-dom'
import PagamentoRoutes from 'modules/pagamentos/utils/PagamentoRoutes'

interface RequisitosProp {
  openModal: boolean
  setOpenModal()
}
const Requisitos: FunctionComponent<RequisitosProp> = ({
  openModal,
  setOpenModal,
}) => {
  const history = useHistory()

  return (
    <Modal
      openModal={openModal}
      size="medium"
      showCloseButton={true}
      onCloseModal={setOpenModal}
    >
      <Grid
        container
        justifyContent="flex-start"
        alignItems="flex-start"
        style={{ padding: 16 }}
      >
        <Grid item xl={11} lg={11} md={11} xs={11}>
          <Title>Pronto para ter sua conta digital no Tmov Pay?</Title>
          <Subtitle>
            Antes de começar, confira alguns requisitos essenciais para abrir
            sua conta.
          </Subtitle>
          <Grid container style={{ padding: '8px 0' }}>
            <MdOutlinePeopleAlt
              style={{
                width: 16,
                height: 16,
                color: colors.green,
                marginRight: 23,
              }}
            />
            <Text>Ser dono, sócio ou representante legal da empresa</Text>
          </Grid>
          <Grid container style={{ padding: '8px 0' }}>
            <BsBriefcase
              style={{
                width: 16,
                height: 16,
                color: colors.green,
                marginRight: 23,
              }}
            />
            <Text>O CNPJ da empresa deve estar ativo</Text>
          </Grid>
          <Grid container style={{ padding: '8px 0' }}>
            <BsPersonCircle
              style={{
                width: 16,
                height: 16,
                color: colors.green,
                marginRight: 23,
              }}
            />
            <Text>Ter foto da CNH</Text>
          </Grid>
          <Grid container style={{ padding: '8px 0' }}>
            <AiOutlineFileText
              style={{
                width: 16,
                height: 16,
                color: colors.green,
                marginRight: 23,
              }}
            />
            <Text>Possuir documentos da empresa em PDF</Text>
          </Grid>
        </Grid>
        <Grid container justifyContent="flex-end">
          <Button
            color={colors.green}
            onClick={() => history.push(PagamentoRoutes.ONBOARDING)}
          >
            Começar
          </Button>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default Requisitos
